import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { GeneralElementSettings, SettingsSetterDirective } from 'src/business/models/general-element-settings';
import { UmbracoIcon } from 'src/core-lib/umbraco/umbraco-image.model';



export interface ButtonSettings extends GeneralElementSettings {
    style: string;
    size: string;
    downloadName?: string;
    download: boolean;
    arrow?: boolean;
    alignSelf?: string;
    family?: string;
    weight?: string;
    type?: string;
}

@Component({
    selector: 'button-element',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonElementComponent extends SettingsSetterDirective implements OnDestroy, OnInit {
    public label: string;
    public link: string;
    public anchor?: string;
    public arrow: boolean;
    public declare settings: ButtonSettings;
    script: HTMLScriptElement;

    @HostBinding('style.--align')
    align: string;
    @HostBinding('style.--font-size')
    size: string;
    @HostBinding('style.--font-weight')
    weight: string;
    @HostBinding('attr.type')
    type: string;

    ngOnInit(): void {
        super.ngOnInit();
        this.align = this.settings?.alignSelf ?? 'start';
        var size = this.settings?.size ? ('--font-' + this.settings?.size) : '--font-size-24';
        this.size = `var(${size})`;
        this.weight = this.settings?.weight ?? '200';
        this.type = this.settings?.style ?? 'text-only';
        this.margin = null
    }
    ngOnDestroy(): void {
        if (this.script)
            document.body.removeChild(this.script);
    }
    runLink() {
        if (this.script)
            document.body.removeChild(this.script);
        this.script = document.createElement('script');
        this.script.type = 'application/javascript';
        this.script.innerHTML = this.link;
        document.body.append(this.script);
    }
    goTo(anchor: string) {
        document.getElementById(anchor)?.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'start'
        });
    }
}
